const Blockly = require('blockly');

const TOOLTIP = 'Create a menu';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    // need this until all RN apps can handle this Menu instead of MeatballProfileLayout
    blocklyBlock.setPreviousStatement(true);
    blocklyBlock.setNextStatement(false);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    blocklyBlock.appendStatementInput('children').appendField('Children:', 'childrenField');
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
